module.exports = __webpack_public_path__ + "assets/img/sy.7d87668f.png";